(function () {
  var MOBILE_BREAKPOINT = 980;
  var headers = document.querySelectorAll('header.full-width');
  var searchForms = document.querySelectorAll('.search-bar');

  headers.forEach(function (header) {
    var toggle = header.querySelector('.header-menu-toggle');
    var menu = header.querySelector('.header-mobile-menu');
    var overlay = header.querySelector('.header-menu-overlay');
    if (!toggle || !menu || !overlay) return;

    function isMobile() {
      return window.innerWidth <= MOBILE_BREAKPOINT;
    }

    function openMenu() {
      if (!isMobile()) return;
      header.classList.add('is-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close navigation menu');
      menu.hidden = false;
      overlay.hidden = false;
    }

    function closeMenu() {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
      menu.hidden = true;
      overlay.hidden = true;
    }

    toggle.addEventListener('click', function () {
      if (header.classList.contains('is-menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('click', function (event) {
      if (!isMobile()) return;
      if (!header.classList.contains('is-menu-open')) return;
      if (header.contains(event.target)) return;
      closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

    overlay.addEventListener('click', function () {
      closeMenu();
    });

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        closeMenu();
      }
    });
  });

  searchForms.forEach(function (form) {
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    form.addEventListener('submit', function (event) {
      var query = input.value.trim();
      if (!query) {
        event.preventDefault();
        input.focus();
        return;
      }

      // Submit the form normally so its product-only search type is included.
      input.value = query;
    });
  });
})();
